(function () {
  function init(root) {
    const track = root.querySelector('.hf-brands__track');
    const prev = root.querySelector('[data-hf-prev]');
    const next = root.querySelector('[data-hf-next]');
    if (!track || (!prev && !next)) return;

    const step = () => Math.max(240, Math.round(track.clientWidth * 0.7));

    if (prev) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-hf-brands]').forEach(init);
  });
})();